import { AuthorProfileController } from '../forum/controllers/AuthorProfileController.js';
import { AuthorForumTopicsController } from '../forum/controllers/AuthorForumTopicsController.js';
import { BasePage } from '../../base/BasePage.js';

export class ForumTopicCreatePage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const auctionId = window.appData?.auctionId;
        const sectionId = window.appData?.sectionId;
        const authorId = window.appData?.authorId;
        const currencyId = window.appData?.currencyId;
        const cp = window.appData?.cp;

        this.initResource({
            controller: new AuthorProfileController(),
            event: 'forum.authorProfile',
            cacheKey: `forum.authorProfile.${cp}`,
            payload: { token, locale, auctionId, sectionId, authorId, currencyId }
        });

        this.initResource({
            controller: new AuthorForumTopicsController(),
            event: 'forum.authorTopics',
            cacheKey: `forum.authorTopics.${cp}`,
            payload: { token, locale, auctionId, sectionId, authorId, currencyId }
        });
    }
}